<template>
    <v-dialog v-model="showDialog" width="600px">
        <v-card>
            <v-card-title class="justify-center">Approve/decline {{ encrids.length }} with a remark</v-card-title>
            <v-divider></v-divider>
            <v-textarea class="pa-4" v-model="remark"></v-textarea>
            <v-divider></v-divider>

            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <btn_component type="avatar_icon"             :color="green"   tooltip="Approve selected changes" icon="mdi-check-circle-outline" :disabled="remark.length<5" :data="true"  @actionClick="approveDeclineWzvzSelectedRemark"/>
                <btn_component type="avatar_icon"             :color="red"     tooltip="Decline selected changes" icon="mdi-close-circle-outline" :disabled="remark.length<5" :data="false" @actionClick="approveDeclineWzvzSelectedRemark"/>
                <btn_component type="text" text="Save remark"  color="primary" tooltip="Save remark & close"      size="x-small"                                               data=""      @actionClick="saveCloseDialog"/>
                <btn_component type="text" text="Cancel"       color="primary" tooltip="Cancel approve/decline"   size="x-small"                                               data=""      @actionClick="closeDialog"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    
    export default {
        components: {
            btn_component,
        },    
        data() {
            return {
                showDialog: false,
                remark: "",
                remark_keep: "",
                red: "grey",
                green: "grey",
                encrids: [],
            }
        },
        watch: {
            remark(newValue) {
                if (newValue.length >= 5) {
                    this.red ="red";
                    this.green ="green";
                    return;
                } 
                this.red ="grey";
                this.green ="grey";
            }
        },    
        methods: {  
            openDialog(encrids, remark) {
                this.remark = remark;
                this.remark_keep = remark;
                this.encrids = encrids;
                this.showDialog = true;
            },
            approveDeclineWzvzSelectedRemark(approve) {
                if (this.remark.length < 5) {
                    return;
                }
                this.$emit("approveDeclineWzvzSelectedRemark", approve, this.remark)
                this.closeDialog();
            },
            saveCloseDialog() {
                this.$emit("saveSelectedRemark", this.remark, this.remark_keep)
                this.closeDialog();
            },
            closeDialog() {
                this.showDialog = false;
            },
        }
    }
</script>

<style scoped> 

</style>